const API_BASE_URL = "https://backend-luezxrsq7q-uc.a.run.app" //"http://127.0.0.1:8000";//"https://backend-ao4yls34ba-uc.a.run.app" //"http://127.0.0.1:8000"; // https://backend-ao4yls34ba-uc.a.run.app

export { API_BASE_URL };